import RewardScreen from "./RewardScreen";

export default RewardScreen;